// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"30ffe06c","143":"cbe1948d","186":"5ccf5070","381":"f3a0e4b6","494":"626250a4","533":"02065213","682":"2fcd6231","852":"9ca2eeff","940":"b93e0e6e"}[chunkId] + ".chunk.js";
};